import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as r, openBlock as d, normalizeClass as n, createElementVNode as i } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconFiles",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(t).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ i("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.5 3.3a.5.5 0 0 1 .5.5v6.4c0 .037.024.117.104.196.08.08.159.104.196.104h4.9a.5.5 0 0 1 0 1H2.3c-.363 0-.683-.176-.904-.396A1.301 1.301 0 0 1 1 10.2V3.8a.5.5 0 0 1 .5-.5Z",
  fill: "currentColor"
}, null, -1), u = /* @__PURE__ */ i("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3.396.896C3.616.676 3.937.5 4.3.5h3.45a.5.5 0 0 1 .354.146l2.25 2.25a.5.5 0 0 1 .146.354V8.2c0 .363-.176.683-.396.904-.22.22-.541.396-.904.396H4.3c-.363 0-.683-.176-.904-.396A1.301 1.301 0 0 1 3 8.2V1.8c0-.363.176-.683.396-.904ZM4.3 1.5c-.037 0-.117.024-.196.104-.08.08-.104.159-.104.196v6.4c0 .037.024.117.104.196.08.08.159.104.196.104h4.9c.037 0 .117-.024.196-.104.08-.08.104-.159.104-.196V4h-2a.5.5 0 0 1-.5-.5v-2H4.3ZM8 3V2l1.043 1H8Z",
  fill: "currentColor"
}, null, -1), h = [
  _,
  u
];
function f(a, m, l, p, v, e) {
  return d(), r("svg", {
    "aria-label": l.ariaLabel,
    class: n([e.iconSizeClass, "d-icon d-icon--files"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Files",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, h, 10, c);
}
const H = /* @__PURE__ */ o(s, [["render", f]]);
export {
  H as default
};
//# sourceMappingURL=files.js.map
